export const DAYS = [
  { id: 1, name: 'Lundi', short: 'Lun' },
  { id: 2, name: 'Mardi', short: 'Mar' },
  { id: 3, name: 'Mercredi', short: 'Mer' },
  { id: 4, name: 'Jeudi', short: 'Jeu' },
  { id: 5, name: 'Vendredi', short: 'Ven' },
  { id: 6, name: 'Samedi', short: 'Sam' },
  { id: 7, name: 'Dimanche', short: 'Dim' },
];

export const TIME_SLOTS = (() => {
  const slots = [];
  for (let h = 0; h < 24; h++) {
    slots.push(`${String(h).padStart(2, '0')}:00`);
    slots.push(`${String(h).padStart(2, '0')}:30`);
  }
  return slots;
})();

export const DURATIONS = [
  { value: 30, label: '30 min' },
  { value: 60, label: '1h' },
  { value: 90, label: '1h30' },
  { value: 120, label: '2h' },
  { value: 150, label: '2h30' },
  { value: 180, label: '3h' },
];

export const BROADCAST_TYPES = [
  { value: 'premiere', label: 'Première', color: '#D84315' },
  { value: 'new', label: 'Nouveauté', color: '#2E7D32' },
  { value: 'live', label: 'Direct', color: '#C62828' },
  { value: 'rerun', label: 'Rediffusion', color: '#9E9E9E' },
];
